import type { IconProps } from '../types/IconProps.ts';
export const RotateCwSquare: IconProps = {
    name: 'RotateCwSquare',
    children: [
        `<path d="M15.5 5H17a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3.25M11 5H7a2 2 0 0 0-2 2v3.25" />`,
        `<path d="m9 2 2.3 2.3a1 1 0 0 1 0 1.4L9 8" />`,
    ]
};